<template>
  <div class="d-flex flex-column flex-md-row">
    <v-sheet width="100%">
      <SearchField />

      <ProductCategorySelect v-if="categoryId" />
    </v-sheet>
  </div>
</template>

<script>
import SearchField from "./fields/SearchField.vue";
import ProductCategorySelect from "./fields/ProductCategorySelect.vue";
import { productFilter } from "../../utils/productFilter";

const _data = {
  loading: true,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    SearchField,
    ProductCategorySelect,
  },
  mixins: [productFilter],
};
</script>
